/** Reduce una foto tomada con el teléfono a una miniatura cuadrada.
 *
 *  Las fotos de cámara pesan varios MB; guardarlas tal cual llenaría
 *  IndexedDB y haría lento cada arranque. 480px de lado es más que
 *  suficiente para una tarjeta de producto. */
export async function comprimirImagen(archivo: File, lado = 480, calidad = 0.82): Promise<string> {
  const bitmap = await createImageBitmap(archivo)
  const recorte = Math.min(bitmap.width, bitmap.height)
  const canvas = document.createElement('canvas')
  canvas.width = lado
  canvas.height = lado

  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Este navegador no permite procesar imágenes.')
  ctx.imageSmoothingQuality = 'high'
  ctx.drawImage(
    bitmap,
    (bitmap.width - recorte) / 2,
    (bitmap.height - recorte) / 2,
    recorte,
    recorte,
    0,
    0,
    lado,
    lado,
  )
  bitmap.close()
  return canvas.toDataURL('image/jpeg', calidad)
}

/** Comprime una imagen para el material de marketing mensual (mapa de
 *  cobertura, lista de precios, tarjeta de presentación): a diferencia
 *  de la foto de producto, acá no conviene recortar a cuadrado —son
 *  documentos que hay que poder leer completos—, así que se conserva
 *  el aspecto original y solo se limita el lado más largo. */
export async function comprimirDocumento(archivo: File, ladoMax = 1600, calidad = 0.85): Promise<string> {
  const bitmap = await createImageBitmap(archivo)
  const escala = Math.min(1, ladoMax / Math.max(bitmap.width, bitmap.height))
  const ancho = Math.round(bitmap.width * escala)
  const alto = Math.round(bitmap.height * escala)
  const canvas = document.createElement('canvas')
  canvas.width = ancho
  canvas.height = alto

  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Este navegador no permite procesar imágenes.')
  ctx.imageSmoothingQuality = 'high'
  ctx.drawImage(bitmap, 0, 0, ancho, alto)
  bitmap.close()
  return canvas.toDataURL('image/jpeg', calidad)
}
